import importerActions from 'src/modules/shared/importer/importerActions';
import selectors from 'src/modules/documentCategory/importer/documentCategoryImporterSelectors';
import DocumentCategoryService from 'src/modules/documentCategory/documentCategoryService';
import fields from 'src/modules/documentCategory/importer/documentCategoryImporterFields';
import {i18n} from 'src/i18n';

const documentCategoryImporterActions = importerActions(
  'DOCUMENT_CATEGORY_IMPORTER',
  selectors,
  DocumentCategoryService.import,
  fields,
  i18n('entities.documentCategory.importer.fileName'),
);

export default documentCategoryImporterActions;
